import Vue from "vue";
import App from "./App";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import router from "./router";
import "jquery";
import VueResource from "vue-resource";
import Axios from "axios";
import VueQuillEditor from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import VueClipboard from "vue-clipboard2";
import echarts from "echarts";
import querystring from "qs";
// import tinymce from "tinymce";
// import VueTinymce from "@packy-tang/vue-tinymce";
import "./assets/iconfont/iconfont.css";

// Vue.prototype.$tinymce = tinymce; // 将全局tinymce对象指向给Vue作用域下
// Vue.use(VueTinymce); // 安装vue的tinymce组件

Vue.use(ElementUI);
Vue.use(VueQuillEditor);
Vue.prototype.$qs = querystring;
Vue.prototype.$echarts = echarts;
VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);
Vue.use(VueResource);
Vue.config.productionTip = false;

// 添加响应拦截
Axios.defaults.withCredentials = true;
// Axios.interceptors.response.use(function (response) {
//   if(response.data.code=='3001068'){
//     this.gotoHref('/login')
//   }
//   return response;
// }, function (error) {
//   return Promise.reject(error); // 请求错误的回调函数
// });
Vue.prototype.$axios = Axios;

//获取链接参数
Vue.prototype.getUrlParam = function(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
  var r = window.location.href.split("?")[1]; //匹配目标参数
  r ? (r = r.match(reg)) : (r = null);
  if (r != null) return unescape(r[2]);
  return null; //返回参数值
};
//递归  删除树结构空子集  arr为数据 key为子集字段名
Vue.prototype.deletChildrenbyKuno = function(arr, key) {
  for (var i = 0; i < arr.length; i++) {
    if (arr[i][key].length == 0) {
      delete arr[i][key];
    } else {
      this.deletChildrenbyKuno(arr[i][key], key);
    }
  }
};
//跳转链接  用法：this.gotoHref('MainClient/fileRegistration') MainClient/fileRegistration 为跳转路径
Vue.prototype.gotoHref = function(src) {
  this.$router.push({
    path: src
  });
};
Vue.prototype.alertbox = function(txt, timer) {
  let str = `<p>${txt}</p>`;
  this.$alert(str, "", {
    confirmButtonText: "确定",
    dangerouslyUseHTMLString: true,
    customClass: "myAlert",
    lockScroll: false,
    confirmButtonText: "知道了",
    callback: action => {
      this.$message({
        type: "info",
        message: `action: ${action}`
      });
    }
  });

  return new Promise((resolve, reject) => {
    setTimeout(() => {
      $(".myAlert")
        .find(".el-button")
        .trigger("click");
      resolve();
    }, timer);
  });
};

//时间格式
Vue.prototype.dateFormatter = function(value) {
  let date;
  if (typeof value == "object") {
    date = value;
  } else {
    date = new Date(Date.parse(value.replace(/-/g, "/")));
  }
  let y = date.getFullYear();
  let MM = date.getMonth() + 1;
  MM = MM < 10 ? "0" + MM : MM;
  let d = date.getDate();
  d = d < 10 ? "0" + d : d;
  return y + "-" + MM + "-" + d;
};

Vue.prototype.getCurrentDate = function(format) {
  var now = new Date();
  var year = now.getFullYear(); //得到年份
  var month = now.getMonth(); //得到月份
  var date = now.getDate(); //得到日期
  var day = now.getDay(); //得到周几
  var hour = now.getHours(); //得到小时
  var minu = now.getMinutes(); //得到分钟
  var sec = now.getSeconds(); //得到秒
  month = month + 1;
  if (month < 10) month = "0" + month;
  if (date < 10) date = "0" + date;
  if (hour < 10) hour = "0" + hour;
  if (minu < 10) minu = "0" + minu;
  if (sec < 10) sec = "0" + sec;
  var time = "";
  //精确到天
  if (format == 1) {
    time = year + "-" + month + "-" + date;
  }
  //精确到分
  else if (format == 2) {
    time =
      year + "-" + month + "-" + date + " " + hour + ":" + minu + ":" + sec;
  } else if (format == 3) {
    var oneweekdate = new Date(now - 7 * 24 * 3600 * 1000);
    var y = oneweekdate.getFullYear();
    var m = oneweekdate.getMonth() + 1;
    var d = oneweekdate.getDate();
    time = y + "-" + this.add0(m) + "-" + this.add0(d);
  } else if (format == 5) {
    now.setMonth(now.getMonth() - 1);
    var y = now.getFullYear();
    var m = now.getMonth() + 1;
    var d = now.getDate();
    time = y + "-" + this.add0(m) + "-" + this.add0(d);
  } else if (format == 7) {
    var date = new Date(now);
    date.setDate(date.getDate() - 365);
    var seperator1 = "-";
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var strDate = date.getDate();
    if (month >= 1 && month <= 9) {
      month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
      strDate = "0" + strDate;
    }
    time = year + seperator1 + month + seperator1 + strDate;
  } else if (format == 8) {
    var oneweekdate = now;
    var y = oneweekdate.getFullYear() + 10;
    var m = oneweekdate.getMonth() + 1;
    var d = oneweekdate.getDate();
    time = y + "-" + this.add0(m) + "-" + this.add0(d);
  }
  return time;
};
//判断是否返回登录页
Vue.prototype.returnlogin = function(value) {
  if (
    value.code === 3001068 ||
    value.code == "2000" ||
    value.msg == "无效的凭证"
  ) {
    //value.code=='5000'||
    this.gotoHref("/login");
  }
};
Vue.prototype.add0 = function(val) {
  val = parseInt(val);
  if (val < 10) {
    return "0" + val;
  } else {
    return val;
  }
};
//递归  删除树结构空子集  arr为数据 key为子集字段名
Vue.prototype.deletChildrenbyKuno = function(arr, key) {
  for (var i = 0; i < arr.length; i++) {
    if (arr[i][key].length == 0) {
      delete arr[i][key];
    } else {
      this.deletChildrenbyKuno(arr[i][key], key);
    }
  }
};
Vue.prototype.textareaTo = function(str) {
  var reg = new RegExp("\n", "g");
  var regSpace = new RegExp(" ", "g");

  str = str.replace(reg, "<br>");
  str = str.replace(regSpace, "&nbsp;");

  return str;
};
Vue.prototype.toTextarea = function(str) {
  var reg = new RegExp("<br>", "g");
  var regSpace = new RegExp("&nbsp;", "g");

  str = str.replace(reg, "\n");
  str = str.replace(regSpace, " ");

  return str;
};
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js